/**
 * Contextual hint: a small card inside the panel where the current first-hour step happens.
 * Shown only while that step is the next open one and the guide has not been skipped.
 * Tap-only (no hover): the optional action is a normal 44 px button.
 */
import type { OnboardingStep } from '@galaxis/shared';
import { useGameStore } from '../../store/game-store.ts';
import { GUIDE_COPY } from './steps.ts';

interface GuideHintProps {
  /** The hint appears when the guide's next step is one of these */
  steps: OnboardingStep[];
  /** Overrides the default hint text of the matching step */
  text?: string;
  action?: { label: string; onClick: () => void };
}

export function GuideHint({ steps, text, action }: GuideHintProps) {
  const onboarding = useGameStore(s => s.onboarding);
  if (!onboarding || onboarding.dismissed || !onboarding.next || !steps.includes(onboarding.next)) return null;
  const copy = GUIDE_COPY[onboarding.next];
  return (
    <div className="rounded-lg p-3 text-xs flex flex-col gap-2" role="note" data-testid="guide-hint" data-step={onboarding.next}
      style={{ background: 'rgba(74,158,255,0.1)', border: '1px solid rgba(74,158,255,0.4)', color: '#bfdbfe' }}>
      <div><span aria-hidden>🧭 </span><span className="font-semibold">{copy.title}.</span> {text ?? copy.hint}</div>
      {action && <button type="button" className="btn-secondary" style={{ minHeight: 44 }} onClick={action.onClick}>{action.label}</button>}
    </div>
  );
}
